import { homeStack } from "./stack/homeStack";
import { journeyStack } from "./stack/journeyStack";
import { authStack } from "./stack/authStack";
import { journeyDeliveryStack } from "./stack/journeyDeliveryStack";
import { forumStack } from "./stack/forumStack";
import { muralStack } from "./stack/muralStack";
import { profileStack } from "./stack/profileStack";
import {rankingStack} from "./stack/rankingStack";
import {journeyPerformanceStack} from "./stack/journeyPerformanceStack";


export const routes = [
    ...authStack,
    ...homeStack,
    ...journeyStack,
    ...journeyDeliveryStack,
    ...forumStack,
    ...muralStack,
    ...profileStack,
    ...rankingStack,
    ...journeyPerformanceStack,
];
